import React from 'react'
import PropTypes from 'prop-types'

// Column-driven accessible table (real <th scope="col">); `renderMobileRow` is the list below 600px.

const DataTable = ({
  columns,
  rows,
  rowKey = (row, index) => row.id ?? index,
  renderCell,
  rowProps,
  ariaLabel,
  renderMobileRow,
  className = '',
}) => (
  <>
    <div className={[ 'gl-table-wrap', className ].filter(Boolean).join(' ')}>
      <table className="gl-table" aria-label={ariaLabel}>
        <thead className="gl-table-thead">
          <tr>
            {columns.map((column) => (
              <th
                key={column.key}
                className={[ 'gl-table-th', column.numeric ? 'gl-table-th--num' : '', column.className ]
                  .filter(Boolean).join(' ')}
                scope="col"
              >
                {column.label}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, index) => {
            const { className: rowClassName, ...rowAttrs } = rowProps ? rowProps(row, index) : {}
            return (
              <tr
                className={[ 'gl-table-tr', rowClassName ].filter(Boolean).join(' ')}
                key={rowKey(row, index)}
                {...rowAttrs}
              >
                {columns.map((column) => (
                  <td
                    key={column.key}
                    className={[ 'gl-table-td', column.numeric ? 'gl-table-td--num' : '', column.className ]
                      .filter(Boolean).join(' ')}
                  >
                    {renderCell(row, column, index)}
                  </td>
                ))}
              </tr>
            )
          })}
        </tbody>
      </table>
    </div>

    {renderMobileRow && (
      <div className="gl-table-mobile-list" aria-label={ariaLabel}>
        {rows.map((row, index) => (
          <React.Fragment key={rowKey(row, index)}>
            {renderMobileRow(row, index)}
          </React.Fragment>
        ))}
      </div>
    )}
  </>
)

DataTable.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string.isRequired,
    label: PropTypes.node,
    numeric: PropTypes.bool,
    className: PropTypes.string,
  })).isRequired,
  rows: PropTypes.array.isRequired,
  rowKey: PropTypes.func,
  renderCell: PropTypes.func.isRequired,
  rowProps: PropTypes.func,
  ariaLabel: PropTypes.string,
  renderMobileRow: PropTypes.func,
  className: PropTypes.string,
}

export default DataTable
